import React, { useState, useEffect, useMemo, ChangeEvent } from 'react';
import { Widget, MasterDetailForm, Table, Button, notification } from '@digital/ui';
import { ContratadoOverHeadAnual, RequisitadoAno, atualizarValorContratadoAnoTipoOverHead } from '@app/api/projeto';
import { Collapse, Icon, Input } from 'antd';
import { Distribuicao, adcionarColunaItemTipoOverHead, ContratadoAnoTipoOverHead } from '@app/api/ctrPcs';
import { DistribuicaoRequisitado } from '@app/api/requisitadoOc';

interface FormResumoContratadoProps {
  contratadoOverHeadAnual: ContratadoOverHeadAnual;
  style: any;
  atualizaContratadoTipoOverHead(id: any): void;
}

const { Panel } = Collapse;

const FormTableContratadoOverheadAnual = (props: FormResumoContratadoProps) => {
  const { contratadoOverHeadAnual, style, atualizaContratadoTipoOverHead } = props;
  const [distribuicaoItemSelecionado, setdistribuicaoItemSelecionado] = useState<string>();
  const [resultadoSelecionado, setResultadoSelecionado] = useState<string>();
  const [distribuicao, setDistribuicao] = useState<Distribuicao>();
  const [resultOverHead, setOverHead] = useState<RequisitadoAno[]>();

  const colunaOI = 10
  const colunaPacotePctOi = 200
  const colunaNome = 250
  const colunaAno = 170;

  useEffect(() => {
    const getData = async () => {
      if (contratadoOverHeadAnual) {
        setOverHead(contratadoOverHeadAnual.resultDataTabel);
        setDistribuicao(contratadoOverHeadAnual);
        if (contratadoOverHeadAnual)
          if (contratadoOverHeadAnual.resultDataTabel) {
            let contratado = contratadoOverHeadAnual.resultDataTabel[0];
            if (contratado) {
              setdistribuicaoItemSelecionado(contratado.numero);
            }
          }
      }
    };

    getData();
  }, [contratadoOverHeadAnual]);



  const columsTest = () => {
    const colluns = [];
    colluns.push(
      {
        title: 'Oi',
        dataIndex: 'numero',
        width: colunaOI
      },
      {
        title: 'Código do pacote',
        dataIndex: 'pacotePctOi',
        width: colunaPacotePctOi
      },
      {
        title: 'Nome',
        dataIndex: 'nome',
        width: colunaNome
      },
    );
    if (distribuicao && distribuicao.anos) {
      const distrubuicao = distribuicao as DistribuicaoRequisitado;

      let colunasAnos: {
        title: string;
        dataIndex: string;
        width: number;
        children: (
          | {
            title: string;
            dataIndex: string;
            key: string;
            render: (text: any, record: any, index: any) => JSX.Element;
          }
          | {
            title: string;
            dataIndex: string;
            key: string;
            render?: undefined;
          })[];
      }[] = [];

      distrubuicao.anos.map(ano => {

        colunasAnos.push({
          title: `${ano}`,
          dataIndex: `${ano}`,
          width: colunaAno,
          children: [
            {
              title: '',
              dataIndex: `valorFormatado${ano}`,
              key: `valorFormatado${ano}`,
              render: (text, record, index) => {
                return (
                  <Input
                    id={`${record.ordemInvestimentoRequisicaoCompraSeqId}quantidade${ano}`}
                    name={`${record.ordemInvestimentoRequisicaoCompraSeqId}quantidade${ano}`}
                    onBlur={() => {
                      //cancelar();
                    }}
                    onPressEnter={e => {
                      const evento = (e as unknown) as ChangeEvent<HTMLInputElement>;
                      setdistribuicaoItemSelecionado(record[`numero`]);
                      salvar(record, evento, record[`valor${ano}`], `${ano}`);
                    }}
                    defaultValue={record[`valor${ano}`]}
                    onChange={e => {
                      record[`valor${ano}`] = e.target.value;
                    }}
                  />
                );
              },
            },
          ],
        });
      });
      if (colunasAnos.length > 0) {
        colluns.push({
          title: '',
          key: 'RATEIO',
          children: colunasAnos,
        });
      }
    }

    return colluns;
  };

  const salvar = (
    recorder: ContratadoAnoTipoOverHead,
    event: ChangeEvent<HTMLInputElement>,
    valorAlterado: string,
    ano: string,
  ) => {
    atualizarValorContratadoAnoTipoOverHead(
      recorder.moduloEconomicoContratadoId,
      recorder.ordemInvestimentoId,
      valorAlterado,
      ano,
    ).then(data => {
      atualizaContratadoTipoOverHead(distribuicaoItemSelecionado);
    });
  };

  const btnsDistribuicaoItem = useMemo(() => {
    const actions = [];
    if (
      contratadoOverHeadAnual &&
      contratadoOverHeadAnual.resultDataTabel &&
      contratadoOverHeadAnual.resultDataTabel.length > 0
    ) {
      actions.push(
        <Button
          type="link"
          title="ADICIONAR COLUNA"
          icon="data-add_column"
          disabled={false}
          onClick={() => {
            if (distribuicaoItemSelecionado) {
              adcionarColunaItemTipoOverHead(distribuicaoItemSelecionado).then(data => {
                if (data.valid) {
                  atualizaContratadoTipoOverHead(distribuicaoItemSelecionado);
                }
              });
            } else {
              notification.error('Você deve selecionar um item');
            }
          }}
        />,
      );
    }

    return actions;
  }, [resultadoSelecionado, distribuicaoItemSelecionado, contratadoOverHeadAnual]);

  const rowSelectionTableDistribuicao = {
    onChange: (selectedRowKeys: string, selectedRows: any) => {
      if (selectedRowKeys) {
        var obj = selectedRows[0];
        setdistribuicaoItemSelecionado(obj.numero);
        setResultadoSelecionado(selectedRowKeys);
      } else {
        setdistribuicaoItemSelecionado('');
      }
    },
    getCheckboxProps: (record: { name: any }) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
    selectedRowKeys: resultadoSelecionado,
    type: 'radio',
  };

  const larguraTotal = useMemo(() => {

    let larguraColunaAno = 0;
    if (distribuicao && distribuicao.anos != undefined && distribuicao.anos.length > 0) {
      larguraColunaAno = distribuicao.anos.length * colunaAno;
    }

    return (larguraColunaAno + colunaOI + colunaPacotePctOi + colunaNome);
  }, [distribuicao]);


  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['2']}
        expandIcon={() => <Icon type="arrows-right_4" />}
        style={style}>
        <Panel key="2" header="Overhead anual" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget actions={btnsDistribuicaoItem}>
              <Table
                rowKey="index"
                scroll={{ x: larguraTotal }}
                columns={columsTest()}
                id={"tableOverheadAnual"}
                dataSource={resultOverHead || []}
              />
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormTableContratadoOverheadAnual;
